import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'ml-input',
  template: `
    <mat-form-field class="full-width" color="primary">
      <mat-label *ngIf="label && applyPipes">{{
        label | translate | titlecase
      }}</mat-label>
      <mat-label *ngIf="label && !applyPipes">{{ label }}</mat-label>
      <mat-icon *ngIf="prefixIcon" matPrefix>{{ prefixIcon }}</mat-icon>
      <input
        matInput
        [formControl]="control"
        autocomplete="off"
        [placeholder]="placeholder | translate"
        [type]="type"
        min="0"
        [required]="isRequired"
      />
      <span *ngIf="suffixText" matSuffix>{{ suffixText }}</span>
      <mat-hint *ngIf="hint">{{ hint | translate }}</mat-hint>
      <mat-error *ngIf="control.hasError('required')">
        {{ label | translate | titlecase }} {{ 'is' | translate }}
        <strong>{{ 'required' | translate }}</strong>
      </mat-error>
      <mat-error *ngIf="control.hasError('email')">
        {{ 'email-invalid' | translate }}
      </mat-error>
      <mat-error *ngIf="control.hasError('validatePositiveNumber')">
        {{ 'positive number' | translate }}
      </mat-error>
      <mat-error *ngIf="control.hasError('minlength')">
        {{ 'min-length' | translate }}
        <b>{{ control.errors.minlength.requiredLength }}</b>
        {{ 'characters' | translate }}
      </mat-error>
      <mat-error *ngIf="control.hasError('maxlength')">
        {{ 'max-length' | translate }}
        <b>{{ control.errors.maxlength.requiredLength }}</b>
        {{ 'characters' | translate }}
      </mat-error>
    </mat-form-field>
  `,
  styleUrls: ['./input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputComponent implements OnInit {
  @Input() control: FormControl;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() prefixIcon: string;
  @Input() suffixText: string;
  @Input() applyPipes = true;
  @Input() type = 'text';
  @Input() hint: string;

  constructor() {}

  ngOnInit() {}

  get isRequired(): boolean {
    if (this.control.validator) {
      const validator = this.control.validator({} as AbstractControl);
      if (validator && validator.required) {
        return true;
      }
    }

    return false;
  }
}
